/**
 * App-level providers (PX-W6.1): i18n boot + the org-scoped WebSocket
 * connection, wrapped around the whole route tree by `routes.tsx` (so
 * `main.tsx` stays untouched).
 *
 * `@/i18n/config` is imported for its SIDE EFFECT — the module initialises
 * i18next with the EN+NL resources, applies the stored locale to
 * `<html lang>` and registers the persistence listener. Every component that
 * calls `useTranslation` below this provider sees a configured instance.
 */

import type { ReactNode } from 'react'

import '@/i18n/config'
import { WebSocketProvider } from '@/providers/WebSocketProvider'

/** Compose the app-level providers around the route tree. */
export function AppProviders({ children }: { children: ReactNode }) {
  return <WebSocketProvider>{children}</WebSocketProvider>
}

export default AppProviders
